import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import SleepHistoryPageLazy from "@ch/pages/SleepPage/SleepHistoryPageLazy.tsx";
import SleepLogPageLazy from "@ch/pages/SleepPage/SleepLogPageLazy.tsx";
import SleepPageLazy from "@ch/pages/SleepPage";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate.tsx";

export const sleepRoutes = [
  {
    path: HealthDiaryPathsEnum.SLEEP_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <SleepHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Sleep History",
      }),
      crumb: () => ({
        title: "Sleep History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_SLEEP_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.SLEEP_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <SleepLogPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Sleep Log",
      }),
      crumb: () => ({
        title: "Log Sleep",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_SLEEP_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.SLEEP,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <SleepPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Sleep",
      }),
      crumb: () => ({
        title: "Sleep",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_SLEEP,
      }),
    },
  },
];
